import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  ADMIN: {
    GET_USERS_FROM_EMAILS: (emails) => ({ emails }),
    API: {
      GET_USERS_FROM_EMAILS: apiResourceActionCreator('users')
    }
  }
})

export const apiAction = (authToken, payload) => commonApiActions.authenticated.post(`${API_ENDPOINT}/getUsersFromEmails`, authToken, payload.emails, actions.admin.api.getUsersFromEmails);

function* getUsersFromEmails(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload));
}

const configuration = {
  name: 'getUsersFromEmails',
  action: actions,
  sagas: getUsersFromEmails,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetchingUser: true
    }),
    success: (state, action) => ({
      ...state,
      usersForKaplanUpload: action.payload.users,
      isFetchingUser: false
    }),
    failed: (state, action) => ({
      ...state,
      error: action.payload.error,
      isFetchingUser: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/getUsersFromEmails.js